import { render } from "./ProductCharacteristicsRoster7Screen.vue?vue&type=template&id=6f79406c&scoped=true"
const script = {}

import "./ProductCharacteristicsRoster7Screen.vue?vue&type=style&index=0&id=6f79406c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f79406c"]])

export default __exports__